import {
	FormControl,
	FormItem,
	FormMessage,
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@uturn/ui-kit';
import { useMemo } from 'react';
import type { ControllerRenderProps, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { buildFixedPriceOptions } from '../multi-update-utils';

export const CanAcceptSelect = ({
	field,
	placeholder = 'Select value',
}: {
	field: ControllerRenderProps<FieldValues, string>;
	placeholder?: string;
}) => {
	const { t } = useTranslation();

	const toSelect = (v: unknown): string => {
		if (typeof v === 'boolean') {
			return String(v);
		}
		if (typeof v === 'string') {
			return v;
		}
		return '';
	};
	const fromSelect = (v: string) => v === 'true';
	const fixedPriceOptions = useMemo(() => buildFixedPriceOptions(t), [t]);

	return (
		<FormItem>
			<FormControl>
				<Select
					value={toSelect(field.value)}
					onValueChange={(v) => field.onChange(fromSelect(v))}
				>
					<SelectTrigger className="bg-white">
						<SelectValue placeholder={placeholder} />
					</SelectTrigger>
					<SelectContent>
						{fixedPriceOptions.map((opt) => (
							<SelectItem
								key={String(opt.id ?? opt.value)}
								value={String(opt.value)}
							>
								{opt.label}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</FormControl>
			<FormMessage />
		</FormItem>
	);
};
